function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEthereumDark = function SvgEthereumDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 653 1063",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    }
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m923.983 541.032 326.077 192.649V0L923.983 541.032Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(-923.983)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.06 0v733.682l325.96-192.649L1250.06 0Z",
    style: {
      fill: "#eaeaea",
      fillRule: "nonzero"
    },
    transform: "translate(-923.983)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.983 602.813 1250.06 1062.2V795.463l-326.077-192.65Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    },
    transform: "translate(-923.983)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.06 795.463V1062.2l326.21-459.387-326.21 192.65Z",
    style: {
      fill: "#d0d0d0",
      fillRule: "nonzero"
    },
    transform: "translate(-923.983)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1250.06 392.732-326.077 148.3 326.077 192.649 325.96-192.649-325.96-148.3Z",
    style: {
      fillOpacity: 0.1,
      fillRule: "nonzero"
    },
    transform: "translate(-923.983)"
  }));
};

export default SvgEthereumDark;